import { Box, Tabs, Tab, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PersonalInformation from "../../features/ProfileDetail/personalInformation";
import ProfileTop from "../../features/ProfileDetail/profileTop";
import MainContainer from "../../layout/MainContainer";
import BookingHistory from "features/ProfileDetail/BookingHistory";
import { useLazyGetUserByIdQuery } from "service/auth";
import { showError } from "../../helpers/showToast";
import { useLazyUserDetailsQuery } from "service/user";
import { Loader } from "helpers";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ProfileDetail = () => {
  const navigate = useNavigate();
  const { type, id } = useParams();
  const [getDetail] = useLazyUserDetailsQuery();
  const [loading, setLoading] = useState(false);
  const [details, setUserDetails] = useState();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const getUserDetails = async (id: string) => {
    setLoading(true);
    try {
      const response = await getDetail({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setUserDetails(response?.data);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getUserDetails(id);
    }
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title fdx">
        <div>
          <h1>Profile Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Registrations - Profile Detail
          </p>
        </div>

        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <ProfileTop data={details} />

      <Box className="custom_tabs2" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
          <Tab label="Personal Information" {...a11yProps(0)} />
          <Tab label="Booking History" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <PersonalInformation type={type} data={details} />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <BookingHistory />
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default ProfileDetail;
